export default (state = [], action) => {
  switch (action.type) {
    case 'FETCH_TAGS':
      return [ ...state, ...action.payload ] || false
    case 'POST_TAGS_DETAIL':
      return [ ...state, ...action.payload ] || false
    default:
      return state
  }
}